import React, { useState, useMemo } from 'react';
import { Popover } from 'tea-component';

import './GameRow.scss';
import GameRowItem from './GameRowItem';
const GameRow = (props: any) => {
  const {
    gameInfo = [],
    selectedId,
    isCollect,
    handleCollect,
    searchText,
  } = props;

  const [visible, setVisible] = useState(false);

  const [gameList, isSelected] = useMemo(() => {
    let games = [
      { ...gameInfo, isAllEditions: true },
      ...(gameInfo.mobile_edition_list || []),
    ];
    let gameIds = games.map((item) => item.edition_unified_id);

    return [games, gameIds.includes(selectedId)];
  }, [gameInfo, selectedId]);

  return (
    <>
      {/* drawer-more-item, drawer-item结构 选中需补充is-selected类 */}
      {gameInfo.mobile_edition_list?.length > 0 ? (
        <Popover
          // defaultVisible={true}
          visible={visible}
          onVisibleChange={(visible) => setVisible(visible)}
          placement="right-start"
          trigger="hover"
          overlay={
            // 如果模块高度超过calc(100vh - {父项模块离页面顶部距离});
            // dbo-sub-game-wrap需要动态添加样式bottom: 16px;以保证与页面底部间距，
            // 可能会影响左侧间距，可同步调整left: 16px;
            <div className="dbo-sub-game-wrap">
              <div className="dbo-drawer-more">
                {gameList.map((item: any, index: any) => {
                  return (
                    <GameRowItem
                      isSubGameList={true}
                      key={index + item.edition_unified_id}
                      gameInfo={item}
                      isSelected={selectedId === item.edition_unified_id}
                      isCollect={isCollect}
                      handleCollect={handleCollect}
                    ></GameRowItem>
                  );
                })}
              </div>
            </div>
          }
        >
          <div className={`drawer-item  ${isSelected ? 'is-selected' : ''}`}>
            <div className="drawer-context">
              <GameRowItem
                gameInfo={gameInfo}
                hasMoreArrow
                isCollect={isCollect}
                handleCollect={handleCollect}
                searchText={searchText}
              ></GameRowItem>
            </div>
          </div>
        </Popover>
      ) : (
        <div
          className={`drawer-item  ${
            selectedId === gameInfo.edition_unified_id ? 'is-selected' : ''
          }`}
        >
          <div className="drawer-context">
            <GameRowItem
              gameInfo={gameInfo}
              isCollect={isCollect}
              handleCollect={handleCollect}
              searchText={searchText}
            ></GameRowItem>
          </div>
        </div>
      )}
    </>
  );
};

export default GameRow;
